import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P } from '@slal/ui/typography';
import { MaxWidthContent, Notification, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { SelectedYesNoContent } from './SelectedYesNoContent';
import { useKeyConsiderationsApplicationForm } from './hooks';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>That's ok, but did you know this withdrawal could be affected</Heading>
            <P>
                If you are using this withdrawal to pay off debt, make sure you have considered all your options for
                managing your debts as there may be a better one than using your pension.
            </P>
            <Notification level="warning">
                <P>
                    Money you take from your pension could be used by creditors to pay off any outstanding debts if you
                    don't meet your repayments.
                </P>
                <P markdown>
                    Information on where to seek free impartial advice on managing debts can be obtained from the
                    [MoneyHelper](https://www.moneyhelper.org.uk/en/money-troubles/dealing-with-debt?source=mas).
                </P>
            </Notification>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>Thanks, that makes things easier.</Heading>
        </Article>
    );
};

export const OutstandingDebtsForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'outstandingDebts',
        '/application/key-considerations/means-tested-benefits'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Outstanding debts">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/investment-scams" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
